import React, { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
	const [isDark, setIsDark] = useState(() => {
		return localStorage.getItem("theme") === "dark";
	});

	useEffect(() => {
		document.documentElement.setAttribute(
			"data-theme",
			isDark ? "dark" : "light"
		);
		localStorage.setItem("theme", isDark ? "dark" : "light");
	}, [isDark]);

	const toggle = () => setIsDark((v) => !v);

	return (
		<ThemeContext.Provider value={{ isDark, toggle }}>
			{children}
		</ThemeContext.Provider>
	);
};

export const useTheme = () => useContext(ThemeContext);
